import { useAuthContext } from "providers/Auth";

// Unit-level fees exist for AppFolio (deposit + application fee) and Rent Manager
// (deposit only). The read view and both edit forms gate on this one rule, so a
// fee the card shows is always one the form can edit — manual units included.
export const useUnitFeeFields = () => {
  const { pms } = useAuthContext();

  return {
    showSecurityDeposit: pms.isAppfolio || pms.isRentManager,
    showApplicationFee: pms.isAppfolio
  };
};
